import { Parameters } from '../Schema/Parameters';
import { createStore } from 'satcheljs';

const initialStore: Parameters = {
    mailboxInfo: null,
};

export const getParameterStore = createStore<Parameters>('FilesViewParameterStore', initialStore);
